<mat-form-field class="select-channel">
  <mat-label>Channel</mat-label>
  <input type="text" matInput [formControl]="searchControl" [matAutocomplete]="channelAuto">
</mat-form-field>
<mat-autocomplete #channelAuto="matAutocomplete" [displayWith]="channelName"
                  (optionSelected)="channelSelected($event)">
  <mat-option *ngFor="let channel of channels" [value]="channel">{{ channel.name }}</mat-option>
</mat-autocomplete>
